import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from './url_helper';
import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_ESTABLISHMENT_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Fiscal Year
export const getFiscalYearList = params =>
	apiClient.get(`${url.GET_FISCAL_YEARS}?${stringifyParams(params)}`);
export const getFiscalYearQuery = params =>
	apiClient.get(
		url.GET_FISCAL_YEAR_QUERY + (params ? `?${stringifyParams(params)}` : '')
	);
export const getFiscalYearById = id =>
	apiClient.get(url.GET_FISCAL_YEAR_BY_ID + id);
export const addFiscalYearWithPeriods = fiscalYear =>
	apiClient.post(url.POST_FISCAL_YEAR_WITH_PERIODS, fiscalYear);
export const updateFiscalYear = fiscalYear =>
	apiClient.put(url.PUT_FISCAL_YEAR + fiscalYear._id, fiscalYear);
export const deleteFiscalYear = fiscalYear =>
	apiClient.delete(url.DELETE_FISCAL_YEAR + fiscalYear._id);
